import type { RouteRecordRaw } from 'vue-router';
import router from '@/core/router';

export interface AppModule {
  routes?: Record<string, RouteRecordRaw>;
}

const registerModule = (name: string, module: AppModule) => {
  if (module.routes) {
    for (const route of Object.values(module.routes)) {
      router.addRoute(route);
    }
  }
  console.info(`Module "${name.replace(/Module$/, '')}" registered`);
};

export const registerModules = (modules: Record<string, AppModule>) => {
  Object.entries(modules).forEach(([key, module]) => {
    if (module) registerModule(key, module);
  });
};
